import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {ActivatedRoute, Router, RouterModule} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {EnvironmentService} from '../../../services/environment.service';
import {ApiAgentService} from '../../../services/api-agent.service';
import {GlobalLoaderService} from '../../../services/global-loader.service';
import {CommonModule} from '@angular/common';

declare var Snackbar: any;

@Component({
  selector: 'app-product-update',
  templateUrl: './product-update.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule, RouterModule],
  styleUrls: ['./product-update.component.scss']
})
export class ProductUpdateComponent implements OnInit {
  loading: boolean;
  productForm: FormGroup;
  submitted: boolean;
  selectedProduct: any;
  products: any;
  imageUrl: any;

  subAccountType: any;
  subAccountGovId: any;
  isAccountant: boolean;
  isManager: boolean;
  isSales: boolean;
  isMerchant: boolean;

  @Input('hasSubscribers')
  hasSubscribers = false;

  @Output('product')
  public productOutput = new EventEmitter<any>();

  @Output('close')
  public closeOutput = new EventEmitter<any>();

  constructor(private activatedRouter: ActivatedRoute,
              private translate: TranslateService,
              private loader: GlobalLoaderService,
              private router: Router,
              private environmentService: EnvironmentService,
              private formBuilder: FormBuilder,
              private api: ApiAgentService) {
  }

  checkPermission() {
    this.activatedRouter.queryParams.subscribe(params => {
      let perms = this.environmentService.checkPermission(params['type'], params['govId']);
      this.isAccountant = perms.isAccountant;
      this.isSales = perms.isSales;
      this.isManager = perms.isManager;
      this.isMerchant = perms.isMerchant;
    });
  }

  async ngOnInit() {
    this.productForm = this.formBuilder.group({
      title: ['', [Validators.required]],
      price: ['', [Validators.required, Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
      qty: ['', [Validators.required, Validators.pattern(/\-?\d*\.?\d{1,2}/)]],
      description: [''],
      imageBase64: [''],
    });

    this.closeOutput.subscribe(() => {
      console.log('closeOutput', this.closeOutput);
      this.hasSubscribers = true;
    });

    this.loading = false;

    // @ts-ignore
    this.productForm.get('description').disable();
    await this.loader.loadExternalStyles('/plugins/notification/snackbar/snackbar.min.css');
    await this.loader.loadExternalScript('/plugins/notification/snackbar/snackbar.min.js');
    await this.loadProductData();

    // this.imageUrl = './assets/img/no-image.png';
    this.imageUrl = null;
  }

  showToast(msg: any) {
    Snackbar.show({
      text: msg,
      pos: 'bottom-center'
    });
  }

  async loadProductData() {
    this.products = await this.api.loadProducts();
    this.products = this.products.filter((item: any) => item.stockQty > 0);
    this.checkPermission();
  }

  async selectProduct(productId: any) {
    if (productId && productId > 0) {
      this.selectedProduct = this.products.filter((item) => item.id == productId)[0];
      console.log('product', this.selectedProduct);
      this.productForm.patchValue({
        description: this.selectedProduct.description,
        price: this.selectedProduct.price,
        qty: 1
      });

      // this.imageUrl = this.environmentService.getRest() + "/openApi/loadProductImage/" + this.selectedProduct.productImageId + "/300/300";
      if (this.selectedProduct.productImageId) {
        this.imageUrl = this.environmentService.getRest() + '/openApi/downloadProductImageBytes/' + this.selectedProduct.id;
      }
    } else {
      this.productForm.patchValue({
        description: null,
        price: null,
        qty: null
      });
      this.imageUrl = null;
    }
  }

  get f() {
    return this.productForm.controls;
  }

  async submitForm() {

    this.submitted = true;

    if (this.productForm.valid) {
      if (!this.selectedProduct) {
        this.showToast(await this.translate.get('Please select a product first').toPromise());
      } else if (this.productForm.value['qty'] <= this.selectedProduct.stockQty) {
        let data = {
          id: this.selectedProduct.id,
          qty: this.productForm.value['qty'],
          title: this.selectedProduct.title,
          price: this.productForm.value['price'],
          imageUrl: this.imageUrl
        };
        console.log('data', data);
        this.productOutput.emit(data);
      } else {
        this.showToast(await this.translate.get('Product qty exceeded the available stock').toPromise());
      }
    } else {
      console.log('errors', this.f);
    }
  }

  closeModal() {
    console.log('closeOutput', this.closeOutput);
    if (this.hasSubscribers) {
      this.closeOutput.emit();
    } else {
      this.router.navigate(['/private', 'products'], {queryParams: {type: this.subAccountType, govId: this.subAccountGovId}}).then();
    }
  }
}
